.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.search-row {
  display: flex;
  gap: 8px;
}

.search-input {
  background: var(--color-card, #fff);
  border: 1px solid var(--color-border, #d4d4d8);
  border-radius: 6px;
  color: var(--color-foreground, #18181b);
  flex: 1;
  font-size: 14px;
  padding: 8px 12px;
}

.search-input:focus {
  border-color: var(--color-ring, #71717a);
  outline: 0;
}

.grid {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  max-height: 360px;
  overflow-y: auto;
}

.tile {
  background: transparent;
  border: 2px solid transparent;
  border-radius: 6px;
  cursor: pointer;
  overflow: hidden;
  padding: 0;
  position: relative;
  transition: border-color 120ms ease;
}

.tile:hover {
  border-color: var(--color-ring, #71717a);
}

.tile-is-selected {
  border-color: var(--color-primary, #18181b);
}

.tile img {
  display: block;
  height: 96px;
  object-fit: cover;
  width: 100%;
}

.empty {
  color: var(--color-muted-foreground, #71717a);
  font-size: 13px;
  padding: 16px;
  text-align: center;
}

.footer {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.btn {
  background: var(--color-primary, #18181b);
  border: 0;
  border-radius: 6px;
  color: var(--color-primary-foreground, #fff);
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  padding: 8px 16px;
}

.btn:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.caption {
  color: var(--color-muted-foreground, #71717a);
  font-size: 12px;
}
